// extracted by mini-css-extract-plugin
export default {"video":"Start_video__4Yq2V","overlay":"Start_overlay__V265w","absolute":"Start_absolute__uS0DZ","text":"Start_text__rkNPp","imag":"Start_imag__IyQeE"};